import React from 'react';
import { Alert } from '@mui/material';
import { connect } from 'react-redux';
import { UIActions } from '../../redux/actions';
import { Snackbar } from '@mui/material';
import { isUndefined } from 'lodash';

type SnackbarProps = {
	snackbarMessage: string;
	isSnackbarOpen: boolean;
	setSnackbarOpen: Function;
	snackbarStatus: any;
	snackbarAutohide: any;
};

const SnackbarComponent: React.FC<SnackbarProps> = props => {
	const handleClose = () => props.setSnackbarOpen(false);
	const messageWithBreaks = props.snackbarMessage ? props.snackbarMessage.split('\n') : [''];

	return (
		<Snackbar
			open={props.isSnackbarOpen}
			onClose={handleClose}
			autoHideDuration={props.snackbarAutohide}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
		>
			<Alert onClose={handleClose} severity={props.snackbarStatus} style={{ width: '100%' }}>
				{messageWithBreaks.map(line => (
					<div key={Math.random()}>{line}</div>
				))}
			</Alert>
		</Snackbar>
	);
};

const mapStateToProps = (state: any) => ({
	snackbarMessage: state.ui.snackbarMessage,
	snackbarStatus: state.ui.snackbarStatus || 'info', //error, warning, info, success
	isSnackbarOpen: state.ui.isSnackbarOpen,
	snackbarAutohide: isUndefined(state.ui.snackbarAutohide) ? 5000 : state.ui.snackbarAutohide, //state.user.snackbarAutohide = null keeps open until user closes
});

const mapDispatchToProps = (dispatch: any) => ({
	setSnackbarOpen: (isOpen: boolean) => dispatch(UIActions.setSnackbarOpen(isOpen)),
});

const SnackbarConnected = connect(mapStateToProps, mapDispatchToProps)(SnackbarComponent);
export default SnackbarConnected;
